/**
 * Тактильная обратная связь (вибрация) на мобильных устройствах.
 *
 * iOS Safari игнорирует navigator.vibrate() (в целях защиты от злоупотреблений),
 * Android Chrome/Firefox и установленные PWA — поддерживают. Это best-effort.
 *
 * Использование:
 *   import { haptic } from '../src/utils/haptics';
 *   haptic.light();   // добавили в корзину
 *   haptic.medium();  // переключили tab
 *   haptic.success(); // отправили заказ
 */

type HapticType = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' | 'reject';

const PATTERNS: Record<HapticType, number | number[]> = {
  light: 10,
  medium: 20,
  heavy: 40,
  // Принят — короткий двойной чек (восходящий ритм)
  success: [10, 30, 10],
  warning: [20, 40, 20],
  error: [40, 60, 40],
  // Отклонён — длинный нисходящий, чтобы рука почувствовала «нет»
  reject: [60, 40, 20],
};

function trigger(type: HapticType) {
  if (typeof navigator === 'undefined') return;
  if (!('vibrate' in navigator)) return;
  try {
    navigator.vibrate(PATTERNS[type]);
  } catch {
    // тихо игнорируем — не критичный функционал
  }
}

export const haptic = {
  light: () => trigger('light'),
  medium: () => trigger('medium'),
  heavy: () => trigger('heavy'),
  success: () => trigger('success'),
  warning: () => trigger('warning'),
  error: () => trigger('error'),
  reject: () => trigger('reject'),
};
